export const START_WORKING_HOURS = 13
export const END_WORKING_HOURS = 3
